export default __webpack_public_path__ + "static/media/trampapo_02_30.d34e332e.jpg";